const PointSourceControls = () => {
  const EffluentConcentrationsData = [
    {
      facility: 'Arapahoe County Water & Wastewater Authority',
      parameter: 'TP',
      unit: 'mg/L',
      limit: '≤ 0.05 (30-day avg) \nOutfall: 001B',
      discharges_to: 'Lone Tree Creek',
      reporting_requirements: 'Monthly',
      max_reported_value: '0.04 (30-day avg)',
      met_permit_limit: 'Yes',
    },
    {
      facility: 'Arapahoe County Water & Wastewater Authority',
      parameter: 'TIN',
      unit: '--',
      limit: 'No limit or reporting requirement.',
      discharges_to: '--',
      reporting_requirements: '--',
      max_reported_value: '--',
      met_permit_limit: '***',
    },
    {
      facility: 'Pinery Water & Sanitation District',
      parameter: 'TP',
      unit: 'mg/L',
      limit: '≤ 0.05 (30-day avg)\nOutfall: 002A',
      discharges_to: 'Cherry Creek',
      reporting_requirements: 'Monthly',
      max_reported_value: '0.05 (30-day avg)',
      met_permit_limit: 'Yes',
    },
    {
      facility: 'Pinery Water & Sanitation District',
      parameter: 'TIN',
      unit: 'mg/L',
      limit: '10 (daily max)\nOutfall: 002A',
      discharges_to: 'Cherry Creek',
      reporting_requirements: '2 Days/Month',
      max_reported_value: '6.9 (daily max)',
      met_permit_limit: 'Yes',
    },
    {
      facility: 'Parker Water & Sanitation District',
      parameter: 'TP',
      unit: 'mg/L',
      limit: '≤ 0.05 (30-day avg)\nOutfall 002A-NT Combined North and South WRFs',
      discharges_to: 'Regional Reservoir',
      reporting_requirements: '2 Days/Month',
      max_reported_value: '0.02 (30-day avg)',
      met_permit_limit: 'Yes',
    },
    {
      facility: 'Parker Water & Sanitation District',
      parameter: 'TP',
      unit: 'mg/L',
      limit: '0.05 (30-day avg) \nOutfall: 003A Combined North and South WRFs',
      discharges_to: 'Sulfur Gulch',
      reporting_requirements: '2 Days/Month',
      max_reported_value: '0.03 (30-day avg)',
      met_permit_limit: 'Yes',
    },
    {
      facility: 'Parker Water & Sanitation District',
      parameter: 'TIN',
      unit: 'mg/L',
      limit: '10 (daily max) \nOutfall: 002A-NT: Combined North and South WRFs',
      discharges_to: 'Regional Reservoir',
      reporting_requirements: '3 Days/Week',
      max_reported_value: '6.9 (daily max)',
      met_permit_limit: 'Yes',
    },
    {
      facility: 'Parker Water & Sanitation District',
      parameter: 'TIN',
      unit: 'mg/L',
      limit: '10 (daily max) \nOutfall 003A: Combined North and South WRFs',
      discharges_to: 'Sulfur Gulch',
      reporting_requirements: '3 Days/Week',
      max_reported_value: '7.7 (daily max)',
      met_permit_limit: 'Yes',
    },
    {
      facility: 'Meridian Metropolitan District',
      parameter: 'TP',
      unit: 'mg/L',
      limit: '≤ 0.5* (90-day avg)**',
      discharges_to: 'Land Application',
      reporting_requirements: 'Quarterly',
      max_reported_value: 'No 30-day reporting requirements in Noitice of Authorization **',
      met_permit_limit: 'Yes',
    },
    {
      facility: 'Meridian Metropolitan District',
      parameter: 'TIN',
      unit: '--',
      limit: 'No limit or reporting requirement.',
      discharges_to: '--',
      reporting_requirements: '--',
      max_reported_value: '--',
      met_permit_limit: '***',
    },
    {
      facility: 'Stonegate Village Metropolitan District',
      parameter: 'TP',
      unit: 'mg/L',
      limit: '≤ 0.25* (30-day avg) \nOutfall: 001A',
      discharges_to: 'Storage',
      reporting_requirements: 'Monthly',
      max_reported_value: '0.03 (30-day avg)',
      met_permit_limit: 'Yes',
    },
    {
      facility: 'Stonegate Village Metropolitan District',
      parameter: 'TP',
      unit: 'mg/L',
      limit: '≤ 0.05 (30-day avg)\nOutfall: 002A',
      discharges_to: 'Cherry Creek',
      reporting_requirements: 'Monthly',
      max_reported_value: '0.03 (30-day avg)',
      met_permit_limit: 'Yes',
    },
    {
      facility: 'Stonegate Village Metropolitan District',
      parameter: 'TIN',
      unit: 'mg/L',
      limit: '10 (daily max) \nOutfall: 002A',
      discharges_to: 'Cherry Creek',
      reporting_requirements: '2 Days/Month',
      max_reported_value: '7 (daily max)',
      met_permit_limit: 'Yes',
    },
    {
      facility: 'Plum Creek Water Reclamation Authority',
      parameter: 'TP',
      unit: 'mg/L',
      limit: '≤ 0.05 (30-day avg)\nOutfall: 007A',
      discharges_to: 'Cherry Creek',
      reporting_requirements: 'Monthly',
      max_reported_value: '0.03 (30-day avg)',
      met_permit_limit: 'Yes',
    },
    {
      facility: 'Plum Creek Water Reclamation Authority',
      parameter: 'TIN',
      unit: '--',
      limit: 'No limit or reporting requirement.',
      discharges_to: '--',
      reporting_requirements: '--',
      max_reported_value: '--',
      met_permit_limit: '***',
    },
  ];

  // Declare and configure request overview table
  const EffluentConcentrationsTable = new requestTable({
    container: '#effluent-concentrations-table',
    filterEnabled: false,
    tableHeaders: {
      facility: 'Facility',
      parameter: 'Parameter',
      unit: 'Unit',
      limit: '30-day Avg. TP Limit or Daily Maximum TIN Limit',
      discharges_to: 'Discharges To',
      reporting_requirements: 'Reporting Requirements',
      max_reported_value: 'Max Reported Value',
      met_permit_limit: 'Met Permit Limit?',
    },
    tableActions: [],
    tableData: EffluentConcentrationsData,
  });
  EffluentConcentrationsTable.buildTable();
};
